import {css} from 'lit';

export const style = css`
    .article-info {
        margin: var(--sbkCoreSpacingXl) 0 var(--sbkCoreSpacing3xs) 0;
        font: var(--sbkFormStepsRegularSm);
    }

    .article-info__reading-time {
        &::before {
            content: '\\2022';
            margin: 0 var(--sbkCoreSpacing3xs) 0 var(--sbkCoreSpacing3xs);
        }
    }
`;
